import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFC247",
      "fill-rule": "evenodd",
      d: "M10.837 5.377 9.491 1.965c-.355-.9-1.627-.9-1.982 0L6.163 5.377 2.5 5.603c-.964.06-1.358 1.27-.612 1.885l2.83 2.335-.917 3.551c-.242.936.788 1.685 1.603 1.166L8.5 12.57l3.095 1.97c.815.519 1.845-.23 1.603-1.165l-.916-3.552 2.83-2.335c.745-.615.351-1.826-.614-1.885z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }